// orchestrator-recovery-config.ts
//
// Orchestrator recovery (3.40.0): read `orchestrator_recovery` from the
// MISSION's V2 snapshot (`<controlRoot>/effective-config.v2.json`, rewritten
// on every config load — so a change takes effect mid-run, like
// `max_auto_decisions_per_mission`). Not threaded through `runMissionToIdle`
// (that file sits at the 200-line budget). Missing / unreadable / invalid ⇒
// schema defaults: a snapshot from a CLI before 3.40 has no block at all.
import { readFile } from "node:fs/promises";
import { join } from "node:path";
import { EFFECTIVE_CONFIG_V2_FILE_NAME } from "./effective-config-v2-loader.js";
import {
  ORCHESTRATOR_RECOVERY_DEFAULTS,
  type OrchestratorRecoveryConfig,
  OrchestratorRecoveryConfigSchema,
} from "./schemas/config-v2-schema.js";

export async function readOrchestratorRecoveryConfig(
  controlRoot: string,
): Promise<OrchestratorRecoveryConfig> {
  try {
    const text = await readFile(join(controlRoot, EFFECTIVE_CONFIG_V2_FILE_NAME), "utf8");
    const block = (JSON.parse(text) as { orchestrator_recovery?: unknown }).orchestrator_recovery;
    const parsed = OrchestratorRecoveryConfigSchema.safeParse(block ?? {});
    return parsed.success ? parsed.data : { ...ORCHESTRATOR_RECOVERY_DEFAULTS };
  } catch {
    return { ...ORCHESTRATOR_RECOVERY_DEFAULTS };
  }
}

/** A cap of 0 is the same as `enabled: false` — no journal write either way. */
export function isOrchestratorRecoveryActive(config: OrchestratorRecoveryConfig): boolean {
  return config.enabled && config.max_recoveries_per_mission > 0;
}
